import React, { memo, forwardRef } from "react";
const SvgChi = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M21.144 25.696c-.624 0-1.136-.096-1.536-.288-.4-.176-.752-.464-1.056-.864-.288-.4-.584-.92-.888-1.56l-5.832-12.24a14.164 14.164 0 00-.816-1.488c-.224-.368-.544-.552-.96-.552-.144 0-.288.016-.432.048-.176.022-.36-.1-.36-.278V7.71c0-.306.204-.578.504-.638.16-.048.408-.072.744-.072.48 0 .872.072 1.176.216.32.144.608.392.864.744.272.336.552.816.84 1.44l5.952 12.36c.24.48.448.88.624 1.2.192.336.408.584.648.744.24.176.552.264.936.264.208 0 .4-.016.576-.048a.464.464 0 01.504.458v.707a.517.517 0 01-.408.515 3.814 3.814 0 01-.48.072 6.692 6.692 0 01-.6.024zM9 25.696l6.264-9.864.84 1.944-4.848 7.92H9zm7.512-8.136l-.84-1.944 4.704-8.544h2.256l-6.12 10.488z"
      />
    </svg>
  );
});
SvgChi.displayName = "SvgChi";
const MemoForwardRef = memo(SvgChi);
export default MemoForwardRef;
